(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-size-chart-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-size-chart-tabs')) {
    class BfSizeChartTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.details = this.querySelector('details');
        this.tablist = this.querySelector('[data-size-chart-tablist]');
        this.tabs = Array.from(this.querySelectorAll('[data-size-chart-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-size-chart-panel]'));
        this.chartPlaceholders = Array.from(this.querySelectorAll('[data-bf-kiwi-chart-placeholder]'));
        this.previousButton = this.querySelector('[data-size-chart-previous]');
        this.nextButton = this.querySelector('[data-size-chart-next]');
        this.kiwiScriptUrl = this.dataset.kiwiScriptUrl || '';
        this.handleResize = () => this.updateArrows();
        this.handleDetailsToggle = () => {
          this.updateArrows();
          if (this.details?.open) this.loadKiwiCharts().catch(() => {});
        };
        this.handleFirstInteraction = () => this.loadKiwiCharts().catch(() => {});

        if (!this.tablist || this.tabs.length === 0) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        });

        this.previousButton?.addEventListener('click', () => this.scrollTabs(-1));
        this.nextButton?.addEventListener('click', () => this.scrollTabs(1));
        this.tablist.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.details?.addEventListener('toggle', this.handleDetailsToggle);
        this.addEventListener('pointerdown', this.handleFirstInteraction, { once: true, passive: true });
        this.addEventListener('keydown', this.handleFirstInteraction, { once: true });
        window.addEventListener('resize', this.handleResize);

        this.selectTab(0, false);
        this.updateArrows();
        this.queueKiwiLoad();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.details?.removeEventListener('toggle', this.handleDetailsToggle);
      }

      queueKiwiLoad() {
        if (this.chartPlaceholders.length === 0) return;

        window.setTimeout(() => {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => this.loadKiwiCharts().catch(() => {}), { timeout: 3000 });
            return;
          }

          this.loadKiwiCharts().catch(() => {});
        }, 1500);
      }

      loadKiwiCharts() {
        if (this.kiwiScriptPromise) return this.kiwiScriptPromise;
        if (!this.kiwiScriptUrl || this.chartPlaceholders.length === 0) return Promise.resolve();

        const existingScript = document.querySelector('script[src*="SizingPlugin.prod.js"]');
        if (existingScript) {
          this.dataset.kiwiStatus = 'loaded';
          this.kiwiScriptPromise = Promise.resolve();
          return this.kiwiScriptPromise;
        }

        this.dataset.kiwiStatus = 'loading';
        this.kiwiScriptPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = this.kiwiScriptUrl;
          script.async = true;
          script.dataset.bfKiwiPageLoader = 'true';
          script.onload = () => {
            window.BFAllowKiwiSizeChartLoad = false;
            this.dataset.kiwiStatus = 'loaded';
            resolve();
          };
          script.onerror = () => {
            window.BFAllowKiwiSizeChartLoad = false;
            this.dataset.kiwiStatus = 'error';
            reject(new Error('Kiwi size chart script failed to load.'));
          };

          window.BFAllowKiwiSizeChartLoad = true;
          document.head.appendChild(script);
        });

        return this.kiwiScriptPromise;
      }

      selectTab(index, moveFocus = true) {
        const selectedTab = this.tabs[index];
        if (!selectedTab) return;

        this.tabs.forEach((tab, tabIndex) => {
          const isSelected = tabIndex === index;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        this.dataset.activeChartId = selectedTab.dataset.chartId || '';
        this.dataset.activeProductHandle = selectedTab.dataset.productHandle || '';
        this.loadKiwiCharts().catch(() => {});
        if (moveFocus) {
          const tabStart = selectedTab.offsetLeft;
          const tabEnd = tabStart + selectedTab.offsetWidth;
          const visibleStart = this.tablist.scrollLeft;
          const visibleEnd = visibleStart + this.tablist.clientWidth;

          if (tabStart < visibleStart || tabEnd > visibleEnd) {
            this.tablist.scrollTo({ left: Math.max(0, tabStart - 60), behavior: 'smooth' });
          }

          selectedTab.focus();
        }

        this.dispatchEvent(
          new CustomEvent('bf:size-chart:select', {
            bubbles: true,
            detail: {
              chartId: selectedTab.dataset.chartId || '',
              productHandle: selectedTab.dataset.productHandle || '',
            },
          })
        );
        this.updateArrows();
      }

      handleKeydown(event, index) {
        const lastIndex = this.tabs.length - 1;
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = index === lastIndex ? 0 : index + 1;
        if (event.key === 'ArrowLeft') nextIndex = index === 0 ? lastIndex : index - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = lastIndex;
        if (nextIndex === index) return;

        event.preventDefault();
        this.selectTab(nextIndex);
      }

      scrollTabs(direction) {
        this.tablist.scrollBy({
          left: this.tablist.clientWidth * 0.7 * direction,
          behavior: 'smooth',
        });
      }

      updateArrows() {
        if (!this.previousButton || !this.nextButton) return;

        const maximumScroll = Math.max(0, this.tablist.scrollWidth - this.tablist.clientWidth);
        const needsScrolling = maximumScroll > 2;
        this.previousButton.hidden = !needsScrolling;
        this.nextButton.hidden = !needsScrolling;
        this.previousButton.disabled = this.tablist.scrollLeft <= 2;
        this.nextButton.disabled = this.tablist.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define('bf-size-chart-tabs', BfSizeChartTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-video-section-v8"] && !Shopify.designMode) return;
  try {
    
  class BFVideoTestimonials {
    constructor(root) {
      this.root = root;
      root.querySelectorAll('[data-bf-vt-control]').forEach((button) => {
        button.addEventListener('click', () => this.toggle(button));
      });
      root.querySelectorAll('video').forEach((video) => {
        video.addEventListener('ended', () => this.sync(video));
        video.addEventListener('pause', () => this.sync(video));
        video.addEventListener('play', () => this.sync(video));
      });
    }

    toggle(button) {
      const slide = button.closest('.bf-vt__slide');
      const video = slide.querySelector('video');
      if (video.paused) {
        // Only one at a time, across every slider on the page.
        document.querySelectorAll('.bf-vt__slide video').forEach((other) => {
          if (other !== video) other.pause();
        });
        video.play();
      } else {
        video.pause();
      }
    }

    sync(video) {
      const slide = video.closest('.bf-vt__slide');
      const button = slide.querySelector('[data-bf-vt-control]');
      const playing = !video.paused && !video.ended;
      slide.classList.toggle('is-playing', playing);
      button.setAttribute('aria-label', playing ? button.dataset.labelPause : button.dataset.labelPlay);
    }
  }

  function initBFVideoTestimonials(scope) {
    (scope || document).querySelectorAll('[data-bf-video-testimonials]').forEach((root) => {
      if (root.dataset.bfVtBound === 'true') return;
      root.dataset.bfVtBound = 'true';
      new BFVideoTestimonials(root);
    });
  }

  initBFVideoTestimonials();
  document.addEventListener('shopify:section:load', (event) => initBFVideoTestimonials(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-podiatrist-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  function animateCard(card) {
    if (card.dataset.podstatsDone) return;
    card.dataset.podstatsDone = '1';

    var num = card.querySelector('[data-podstats-num]');
    if (num) {
      var target = parseInt(num.getAttribute('data-target'), 10) || 0;
      var start = null;
      var dur = 1200;
      requestAnimationFrame(function tick(ts){
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        num.textContent = Math.round(p * target);
        if (p < 1) requestAnimationFrame(tick);
      });
    }

    var TOTAL = 1200; // sweep time per bar, matches count-up
    var bar = card.querySelector('.pds-bar');
    if (!bar) return;
    var pct = parseInt(bar.getAttribute('data-pct'), 10) || 0;
    var segEls = bar.querySelectorAll('.pds-seg-fill');
    segEls.forEach(function (el, j) {
      var lo = j * 25;
      var segPts = Math.max(0, Math.min(pct - lo, 25));
      var w = parseFloat(el.getAttribute('data-fill')) || 0;
      el.style.transition = 'none';
      el.style.width = '0%';
      if (pct <= 0 || segPts <= 0) return;
      var delay = (lo / pct) * TOTAL;
      var dur = (segPts / pct) * TOTAL;
      void el.offsetWidth;
      el.style.transition = 'width ' + dur + 'ms linear ' + delay + 'ms';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.style.width = w + '%'; });
      });
    });
  }

  function run(root) {
    var cards = (root || document).querySelectorAll('.prime-podstats [data-podstats-card]');
    if (!cards.length) return;

    if ('IntersectionObserver' in window) {
      // Per-card observer: stacked mobile cards reveal one-by-one on scroll;
      // desktop row cards enter together and animate together.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animateCard(e.target);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.35 });
      cards.forEach(function (card) {
        if (card.dataset.podstatsObserved) return;
        card.dataset.podstatsObserved = '1';
        io.observe(card);
      });
    } else {
      cards.forEach(animateCard);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
